module.exports = __webpack_public_path__ + "img/logo-white.31f35555.png";